/**
 * Resolve a stored path to a browsable URL.
 *
 * Storage lives at <domain>/storage/..., NOT at <api-prefix>/storage/...
 * so we strip any trailing /api, /api/v1, /api/v2 etc. from VITE_API_URL
 * before building the storage URL.
 *
 * Set VITE_STORAGE_URL explicitly to bypass this heuristic.
 */
export function resolveStorageUrl(path: string | null | undefined): string {
  if (!path) return '';
  if (/^https?:\/\//i.test(path)) return path;            // already a URL

  const cleanPath = path.replace(/^\/+/, '');

  // 1. Prefer an explicit storage base if configured
  const explicit = (import.meta as any).env?.VITE_STORAGE_URL as string | undefined;
  if (explicit && explicit.trim()) {
    return `${explicit.replace(/\/+$/, '')}/${cleanPath}`;
  }

  // 2. Fall back to the API base minus its /api[/vN] prefix
  const apiUrl = ((import.meta as any).env?.VITE_API_URL as string | undefined) ?? '';
  if (apiUrl.trim()) {
    const origin = apiUrl
      .replace(/\/+$/, '')
      .replace(/\/api\/v\d+$/, '')
      .replace(/\/api$/, '');
    return `${origin}/storage/${cleanPath}`;
  }

  // 3. Last resort — same-origin
  return `/storage/${cleanPath}`;
}
